import { render, staticRenderFns } from "./CreatePost.vue?vue&type=template&id=040f0918&"
import script from "./CreatePost.vue?vue&type=script&lang=ts&"
export * from "./CreatePost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports